import * as React from "react"
import Cookies from "js-cookie";
import t from "../i18n";
import classNames from "classnames";

declare type LanguageProps = {
    // id: string,
    // className?: string,
    textColor?: string,
    isMobile: boolean,
    isLoggedIn: boolean,
    onLanguageSelected?: () => void;
}
export const LanguageMenu = (props: LanguageProps) => {
    const [visible, setVisible] = React.useState(false);
    const dropDownMenu = React.useRef<HTMLUListElement>(null);
    React.useEffect(() => {
        if (!visible) return;
        const onDocumentClick = (event: Event) => {
            if (!dropDownMenu.current) return;
            // const menu = this.dropDownMenu;
            const target = event.target as HTMLElement;
            const langDropdown = target.closest(".language-menu-source");
            if (!langDropdown) {
                setVisible(false);
                // menu.style.display = "none";
                // document.removeEventListener("click", this.onDocumentClick);
            }
        }
        document.addEventListener("click", onDocumentClick);
        return () => {
            document.removeEventListener("click", onDocumentClick);
        }
    }, [visible]);
    const showDropdown = () => {
        setVisible(true);
    }
    const selectLanguage = (e: React.MouseEvent<HTMLAnchorElement>, language: string, oldLanguage: string) => {
        e.stopPropagation();
        setVisible(false);
        props.onLanguageSelected?.();
        if (language === oldLanguage) return;
        Cookies.set('eto-culture', language);
        window.location.reload();
    }
    const renderDesktop = (lang: string) => {
        const cls = classNames("desktop-menu d-none d-md-flex align-items-start ml-1", props.isLoggedIn ? "flex-column" : "unauthenticated");
        return <div className={cls} onClick={showDropdown}>
            <div style={{ fontSize: 13, textTransform: "uppercase", marginRight: props.isLoggedIn ? 0 : 5 }}>{lang}</div>
            <div className="language-menu-source">
                <i className="fa fa-globe" style={{ fontSize: 17 }} />
                <span className="caret" />
            </div>
            {visible ? <ul className="desktop-menu-dropdown" ref={dropDownMenu} style={{ display: "block" }}>
                <li>
                    <a href="javascript:void(0)" onClick={e => selectLanguage(e, 'en', lang)}>English</a>
                </li>
                <li>
                    <a href="javascript:void(0)" onClick={e => selectLanguage(e, 'es', lang)}>Español</a>
                </li>
                <li>
                    <a href="javascript:void(0)" onClick={e => selectLanguage(e, 'fr', lang)}>Français</a>
                </li>
            </ul> : null}
        </div>
    }
    const renderMobile = (lang: string) => {
        return <div id="mobile" className="menu-group d-flex d-md-none">
            <a onClick={e => selectLanguage(e, 'en', lang)}>English</a>
            <a onClick={e => selectLanguage(e, 'es', lang)}>Español</a>
            <a onClick={e => selectLanguage(e, 'fr', lang)}>Français</a>
        </div>;
    }
    const lang = t.currentLanguage();
    return props.isMobile ? renderMobile(lang) : renderDesktop(lang);
}